import { useLenis } from "lenis/react";
import { Link } from "react-router-dom";
import { NAV_LINKS } from "@/data/site";
import logoMark from "@/assets/nur-logo.png";

export const Footer = () => {
  const lenis = useLenis();
  const go = (id) => {
    const el = document.getElementById(id);
    if (el && lenis) lenis.scrollTo(el, { duration: 1.4 });
  };

  return (
    <footer
      data-testid="site-footer"
      className="border-t border-sage/30 bg-white px-6 py-16 md:px-12"
    >
      <div className="mx-auto flex max-w-[1400px] flex-col gap-12 md:flex-row md:items-end md:justify-between">
        <div>
          <button
            onClick={() => go("hero")}
            className="flex items-center"
            data-testid="footer-logo"
            aria-label="Nur Therapy — home"
          >
            <img src={logoMark} alt="Nur Therapy" className="h-16 w-auto" />
          </button>
          <p className="mt-4 max-w-xs text-sm font-light leading-relaxed text-stone">
            Holistic wellness rooted in nature, on the edge of Epping Forest.
          </p>
        </div>

        <div className="flex flex-wrap gap-8">
          {NAV_LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`footer-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-sm tracking-wide text-stone transition-colors hover:text-forest"
            >
              {l.label}
            </button>
          ))}
          <a
            href="mailto:info@nurtherapy.co.uk"
            className="text-sm tracking-wide text-stone transition-colors hover:text-forest"
          >
            info@nurtherapy.co.uk
          </a>
        </div>
      </div>

      <div className="mx-auto mt-14 flex max-w-[1400px] flex-col gap-2 border-t border-sage/20 pt-6 text-xs text-sage md:flex-row md:items-center md:justify-between">
        <p>© {new Date().getFullYear()} Hilal Organics &amp; Nur Therapies Ltd · Est. 2010. All rights reserved.</p>
        <div className="flex flex-wrap gap-x-6 gap-y-2">
          <Link
            to="/privacy-policy"
            data-testid="footer-privacy"
            className="transition-colors hover:text-forest"
          >
            Privacy Policy
          </Link>
          <Link
            to="/terms"
            data-testid="footer-terms"
            className="transition-colors hover:text-forest"
          >
            Terms &amp; Conditions
          </Link>
          <Link
            to="/cookie-policy"
            data-testid="footer-cookies"
            className="transition-colors hover:text-forest"
          >
            Cookie Policy
          </Link>
        </div>
      </div>
    </footer>
  );
};
